import { IStoreState } from "../../../../reducers/types";
import {
    getIsTravelApp,
} from "../../reducer";
import { connect, ConnectedProps } from "react-redux";
import { PriceMatchBanner } from "./component";

const mapStateToProps = (state: IStoreState) => {
    return {
        isTravelApp: getIsTravelApp(state),
    };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PriceMatchBannerConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPriceMatchBanner = connector(PriceMatchBanner);
